export default {
    FETCHED_DOCUMENT_MONITORING_DETAILS: 'FETCHED_DOCUMENT_MONITORING_DETAILS',
    ADD_EDIT_DOCUMENT_MONITORING: "ADD_EDIT_DOCUMENT_MONITORING",
    UPLOAD_DOCUMENT_FILE: "UPLOAD_DOCUMENT_FILE",
    FETCHED_DOCUMENT_MONITORING_FILE: "FETCHED_DOCUMENT_MONITORING_FILE"
}